"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hex2rgb(color) {
    /* Check for # infront of the value, if it's there, strip it */
    if ((color === null || color === void 0 ? void 0 : color.substring(0, 1)) == '#') {
        color = color.substring(1);
    }
    let rgbColor = {
        r: undefined,
        g: undefined,
        b: undefined,
    };
    /* Grab each pair (channel) of hex values and parse them to ints using hexadecimal decoding */
    if (color) {
        rgbColor.r = parseInt(color === null || color === void 0 ? void 0 : color.substring(0, 2), 16);
        rgbColor.g = parseInt(color === null || color === void 0 ? void 0 : color.substring(2, 4), 16);
        rgbColor.b = parseInt(color === null || color === void 0 ? void 0 : color.substring(4), 16);
    }
    return rgbColor;
}
exports.hex2rgb = hex2rgb;
//# sourceMappingURL=hex2rgb.js.map